export const ANDROID_PLATFORM = 'android';
export const IOS_PLATFORM = 'ios';



// WEBPACK FOOTER //
// ./src/utils/platforms.js